import Phaser from 'phaser';
import { TILE } from '../types';
import { PowerUpSpec } from '../config/powerups';
import { scaleSpriteToTile, fitBodyToTile } from '../systems/SpriteScaling';

export class PowerUp extends Phaser.Physics.Arcade.Sprite {
  readonly col: number;
  readonly row: number;
  readonly spec: PowerUpSpec;

  constructor(scene: Phaser.Scene, col: number, row: number, spec: PowerUpSpec) {
    const x = col * TILE + TILE / 2;
    const y = row * TILE + TILE / 2;
    super(scene, x, y, spec.textureKey);
    this.col = col;
    this.row = row;
    this.spec = spec;
    scene.add.existing(this);
    scaleSpriteToTile(this, TILE - 14);
    scene.physics.add.existing(this);
    fitBodyToTile(this, TILE - 18);
    const body = this.body as Phaser.Physics.Arcade.Body;
    body.setImmovable(true);
    body.setAllowGravity(false);

    // Visual bobbing — operates on scale + rotation so the static body position
    // is unaffected.
    const base = this.scaleX;
    scene.tweens.add({
      targets: this,
      scaleX: { from: base * 0.92, to: base * 1.08 },
      scaleY: { from: base * 0.92, to: base * 1.08 },
      yoyo: true,
      repeat: -1,
      duration: 500,
      ease: 'Sine.easeInOut',
    });
    scene.tweens.add({
      targets: this,
      angle: { from: -8, to: 8 },
      yoyo: true,
      repeat: -1,
      duration: 700,
      ease: 'Sine.easeInOut',
    });
  }
}
